module.exports = __webpack_public_path__ + "03790d465c86fe5a4347db76b9cf8f02.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/name-male-3.svg
// module id = 89
// module chunks = 0